import React from "react"
import Logo from "assets/images/header/mbStar_logo.png"
import { Link } from "gatsby"
import Container from "@mui/material/Container"
import {
  flexBox,
  getMediaFor,
  MEDIA_BREAKPOINT_KEYS,
  responsiveFontSize,
  responsiveImage,
} from "style/style_snippets"
import NavDrawer from "containers/Layout/components/NavDrawer"
import {
  Slide,
  useMediaQuery,
  useScrollTrigger,
  useTheme,
} from "@mui/material"
import AppBar from "@mui/material/AppBar"
import NavBar from "containers/Layout/components/NavBar"
import ic_info from "assets/images/icons/ic_info.png"
import Button from "@mui/material/Button"

export const headerHeight = {
  base: "70px",
  [MEDIA_BREAKPOINT_KEYS.xs]: "70px",
  [MEDIA_BREAKPOINT_KEYS.sm]: "90px",
  [MEDIA_BREAKPOINT_KEYS.md]: "90px",
  [MEDIA_BREAKPOINT_KEYS.lg]: "110px",
}

const headerPadding = {
  paddingTop: 5,
  paddingBottom: 26,
}

const headerStyle = {
  mainWrapper: {
    backgroundColor: "black",
    ...getMediaFor("height", headerHeight.base, {
      [MEDIA_BREAKPOINT_KEYS.xs]: headerHeight[MEDIA_BREAKPOINT_KEYS.xs],
      [MEDIA_BREAKPOINT_KEYS.sm]: headerHeight[MEDIA_BREAKPOINT_KEYS.sm],
      [MEDIA_BREAKPOINT_KEYS.lg]: headerHeight[MEDIA_BREAKPOINT_KEYS.lg],
    }),
    a: {
      textDecoration: "none",
    },
  },

  container: {
    height: "100%",
    ...flexBox.row,
    justifyContent: "space-between",
  },

  logoWrapper: {
    ...flexBox.row,
    justifyContent: "center",
    alignItems: "center",
  },

  logo: {
    ...flexBox.row,
    justifyContent: "center",
    alignItems: "center",
    img: {
      ...responsiveImage,
      ...getMediaFor("maxWidth", 40, {
        [MEDIA_BREAKPOINT_KEYS.xs]: 40,
        [MEDIA_BREAKPOINT_KEYS.sm]: 50,
        [MEDIA_BREAKPOINT_KEYS.md]: 60,
        [MEDIA_BREAKPOINT_KEYS.lg]: 60,
        [MEDIA_BREAKPOINT_KEYS.xl]: 64,
      }),
    },
  },

  description: {
    color: "white",
    fontWeight: 400,
    fontSize: responsiveFontSize(12, 18),
    alignSelf: "flex-end",
    paddingBottom: headerPadding.paddingBottom - 2,
    ...getMediaFor("marginLeft", 10, {
      [MEDIA_BREAKPOINT_KEYS.xs]: 10,
      [MEDIA_BREAKPOINT_KEYS.sm]: 20,
      [MEDIA_BREAKPOINT_KEYS.md]: 40,
      [MEDIA_BREAKPOINT_KEYS.lg]: 50,
      [MEDIA_BREAKPOINT_KEYS.xl]: 64,
    }),
  },

  navWrapper: {
    height: "100%",
    ...flexBox.column,
    justifyContent: "space-between",
    alignItems: "flex-end",
    ...headerPadding,
  },
  legalWrapper: {
    ...flexBox.row,
    justifyContent: "space-between",
    alignItems: "center",
    "*": {
      color: "white",
    },
    img: {
      marginRight: 10,
    },
  },
}

const HideOnScroll = ({ children }) => {
  const trigger = useScrollTrigger()

  return (
    <Slide appear={false} direction="down" in={!trigger}>
      {children}
    </Slide>
  )
}

const Header = ({ setDisclaimerOpenTab }) => {
  const theme = useTheme()
  const mediaMatchXs = useMediaQuery(
    theme.breakpoints.up(MEDIA_BREAKPOINT_KEYS.xs)
  )

  const headerBaseContent = (
    <header css={headerStyle.mainWrapper}>
      <Container maxWidth={"lg"} css={headerStyle.container}>
        <div css={headerStyle.logoWrapper}>
          <NavDrawer />
          <Link css={headerStyle.logo} to={"/"}>
            <img src={Logo} alt="Mercedes-Benz logo" />
          </Link>
          {mediaMatchXs && (
            <Link css={headerStyle.description} to={"/"}>
              Open Source
            </Link>
          )}
        </div>

        <div css={headerStyle.navWrapper}>
          <div css={headerStyle.legalWrapper}>
            <img src={ic_info} alt="ic_info" />
            <Button onClick={() => setDisclaimerOpenTab(0)} variant={"text"} style={{"color": "#FFFFFF"}}>
              Provider/Privacy Statement
            </Button>
          </div>

          {mediaMatchXs && <NavBar />}
        </div>
      </Container>
    </header>
  )

  return (
    <HideOnScroll>
      <AppBar color={"transparent"}>{headerBaseContent}</AppBar>
    </HideOnScroll>
  )
}

export default Header
